import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import {
  useCreateBrokerageEmployeeMutation,
  useUpdateBrokerageEmployeeMutation,
} from "../materialEntered/materialApi";
import useTranslator from "../../../hooks/useTranslator";

const AddEmployeeModal = ({ show, setShow, record, mode }) => {
  const { _t } = useTranslator();
  const [addEmployee] = useCreateBrokerageEmployeeMutation();
  const [editEmployee] = useUpdateBrokerageEmployeeMutation();
  const initialFormData = {
    emp_total: "",
    emp_in_sorting_area: "",
    emp_in_packing_area: "",
    absent_emp: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    setFormData({
      ...initialFormData,
      ...record, // Automatically fills available record values
    });
  }, [show, record]);
  const calculateTotalEmployee = (data) => {
    return (
      Number(data.emp_in_sorting_area) +
      Number(data.emp_in_packing_area) +
      Number(data.absent_emp)
    );
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    if (
      name === "absent_emp" ||
      name === "emp_in_sorting_area" ||
      name === "emp_in_packing_area"
    ) {
      updatedFormData.emp_total =
        Number(updatedFormData.absent_emp) +
        Number(updatedFormData.emp_in_sorting_area) +
        Number(updatedFormData.emp_in_packing_area);
    }

    setFormData(updatedFormData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const calculatedEmp = calculateTotalEmployee(formData);

    const mutation = mode === "add" ? addEmployee : editEmployee;

    try {
      const payload =
        mode === "add"
          ? formData
          : { id: record.emp_id, requestBody: formData };
      await mutation(payload).unwrap();

      handleClose();
    } catch (error) {
      console.error("Error creating/updating employee:", error);
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          label={_t("total_employees", "Total Employees")}
          type="number"
          name="emp_total"
          value={calculateTotalEmployee(formData)}
          onChange={handleChange}
          placeholder={"0"}
          disabled={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("employees_in_sorting_area", "Employees in Sorting Area")}
          type="number"
          name="emp_in_sorting_area"
          value={formData.emp_in_sorting_area}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("employees_in_packig_area", "Employees in Packing Area")}
          type="number"
          name="emp_in_packing_area"
          value={formData.emp_in_packing_area}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>

      <Col lg={6}>
        <InputWithLabel
          label={_t("absent_employees", "Absent Employees")}
          type="number"
          name="absent_emp"
          onChange={handleChange}
          value={formData.absent_emp}
          placeholder={"0"}
        />
      </Col>
    </>
  );
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("adding_employees_data", "Adding Employees Data")}
    >
      <Row>{renderFormFields()}</Row>
      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            // isLoading={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default AddEmployeeModal;
